module.exports = __webpack_public_path__ + "static/media/p4ru.67d667d5.pdf";